var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg"},[_c('div',{attrs:{"id":"chat"}},[_c('div',{staticClass:"sidebar"},[_c('kt-panel')],1),_vm._v(" "),_c('div',{staticClass:"main"},[_c('kt-header'),_vm._v(" "),_c('kt-content'),_vm._v(" "),_c('kt-tool')],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d956e75e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/chat/chat.vue
// module id = S9PL
// module chunks = 1